import { takeEvery } from 'redux-saga/effects';
import Debug from 'debug';

const debug = Debug('@signageos/front-display:Debug:debugSagas');

export function* debugAllActions() {
	yield takeEvery('*', function* (action: any): IterableIterator<any> {
		debug(action.type, action);
	});
}
